/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cat_Destek_TitleInputs */

const tr_faq_cat_destek_title = /** @type {(inputs: Faq_Cat_Destek_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destek ve İletişim`)
};

const en_faq_cat_destek_title = /** @type {(inputs: Faq_Cat_Destek_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support & Contact`)
};

const de_faq_cat_destek_title = /** @type {(inputs: Faq_Cat_Destek_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support und Kontakt`)
};

const ru_faq_cat_destek_title = /** @type {(inputs: Faq_Cat_Destek_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддержка и контакты`)
};

/**
* | output |
* | --- |
* | "Support & Contact" |
*
* @param {Faq_Cat_Destek_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_cat_destek_title = /** @type {((inputs?: Faq_Cat_Destek_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cat_Destek_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_cat_destek_title(inputs)
	if (locale === "de") return de_faq_cat_destek_title(inputs)
	if (locale === "ru") return ru_faq_cat_destek_title(inputs)
	return tr_faq_cat_destek_title(inputs)
});